import axios from "axios";
import { ActionTypes } from "utils/constants";
import { getEnvVar } from "utils/get-env-var";

export const fetchSeries = () => ({
    type: ActionTypes.FETCH_SERIES,
    payload: axios.get(`${getEnvVar('API_BASE')}/series`)
});
